var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaiterService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1477412_butler_order_restaurant_service_serving_icon_1_",
    "data-name": "1477412_butler_order_restaurant_service_serving_icon (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#7d9aa7}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(13.8 27.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    className: "cls-1",
    d: "M1401.293 465.37a7.771 7.771 0 0 1 5.562 2.346 8.114 8.114 0 0 1 0 11.329 7.766 7.766 0 0 1-11.124 0 8.114 8.114 0 0 1 0-11.329 7.772 7.772 0 0 1 5.562-2.346z",
    transform: "translate(-1321.395 -463.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    className: "cls-1",
    d: "M1169.492 733.065a1.99 1.99 0 0 0-.228.209l-5.3 5.649-10.333 1.932a4.743 4.743 0 0 0-3.189 1.822 4.9 4.9 0 0 0-1 3.469 2.1 2.1 0 0 0 .027.232 4.871 4.871 0 0 0 1.773 3.125 4.694 4.694 0 0 0 3.406 1.02 1.939 1.939 0 0 0 .3-.044l10.385-1.374.108-.009a6.293 6.293 0 0 0 2.223-.58 5.407 5.407 0 0 0 1.286-.87l.068 2.487v.109h.006v.058c.027.417.374.344.217.463-.061.046-.366-.05-1.089-.05h-5.3a6.662 6.662 0 0 0-4.1 1.487 6.918 6.918 0 0 0-2.4 3.608 2.43 2.43 0 0 0-.033.129h.006l-4.511 20.486-.026.094a5.461 5.461 0 0 0 .579 4.084 5.305 5.305 0 0 0 3.152 2.455 1.94 1.94 0 0 0 .189.049 5.2 5.2 0 0 0 3.92-.612 5.378 5.378 0 0 0 2.411-3.21 2.023 2.023 0 0 0 .067-.3l1.919-9.981a17.293 17.293 0 0 1 1.412-4.449c.218-.33.624-.446 1.391-.446h4.848a12.108 12.108 0 0 0 8.291-2.98 12.39 12.39 0 0 0 3.876-8.006c.29-2.573-.539-7.285-1.237-11.252-.291-1.655-.559-3.174-.7-4.274a13.034 13.034 0 0 0-1.472-5.181c-1.112-1.813-2.877-2.97-5.848-2.7a5.587 5.587 0 0 0-2.987 1.187 13.484 13.484 0 0 0-1.928 1.908 2.04 2.04 0 0 0-.19.252z",
    transform: "translate(-1092.414 -711.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    className: "cls-1",
    d: "M1400.57 978.058a1.969 1.969 0 1 0-3.911-.455l-2.042 18.231h-15.51a1.981 1.981 0 0 0-1.936 1.627l-4.308 15.856a2.006 2.006 0 0 0 1.371 2.462 1.962 1.962 0 0 0 2.418-1.4l3.949-14.535h15.772a1.985 1.985 0 0 0 1.959-1.78l2.241-20.011z",
    transform: "translate(-1302.031 -941.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    className: "cls-1",
    d: "M1663.709 1296.312a1.965 1.965 0 0 0-2.41-1.419 2.009 2.009 0 0 0-1.394 2.454l4.193 15.937a1.966 1.966 0 0 0 2.41 1.419 2.009 2.009 0 0 0 1.394-2.454z",
    transform: "translate(-1571.397 -1240.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    className: "cls-1",
    d: "M642.451 1043.6a2.008 2.008 0 0 0 0-4.015h-33.406a2.008 2.008 0 0 0 0 4.015z",
    transform: "translate(-583.48 -1001.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    className: "cls-1",
    d: "M712.73 1040.549a1.946 1.946 0 0 0-2.726-.565 2.026 2.026 0 0 0-.554 2.776l20.842 32.018a1.945 1.945 0 0 0 2.726.565 2.026 2.026 0 0 0 .554-2.776z",
    transform: "translate(-679.242 -1001.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    className: "cls-1",
    d: "M733.57 1042.759a2.026 2.026 0 0 0-.554-2.776 1.945 1.945 0 0 0-2.726.564l-20.842 32.018a2.025 2.025 0 0 0 .554 2.776 1.945 1.945 0 0 0 2.726-.564z",
    transform: "translate(-679.241 -1001.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    className: "cls-1",
    d: "M239.027 663.147a1.985 1.985 0 0 0-.278-.305 7.865 7.865 0 0 0-2.749-1.565 10.289 10.289 0 0 0-3.251-.518 8.761 8.761 0 0 0-5.928 2.269 7.731 7.731 0 0 0-2.564 5.7v.017h.008l-.158 19.355a2.056 2.056 0 0 0-.009.177l1.971.015-1.963-.008c0 .66-.02 1.3-.034 1.875-.1 4.317-.131 5.421 3.488 9.2l.075 16.657c0 .055-.007.111-.007.168a4.086 4.086 0 0 0 1.558 3.167 1.987 1.987 0 0 0 .158.134 5.827 5.827 0 0 0 6.727.062q.043-.029.084-.061a4.121 4.121 0 0 0 1.719-3.3v-.009h-.008l-.076-16.823c3.683-3.842 3.672-4.915 3.616-9.962 0-.279-.006-.573-.009-.863 0-.059.007-.119.006-.18h-.008l-.091-9.618 2.066 1.589a4.3 4.3 0 0 0 1.292.924 3.953 3.953 0 0 0 1.6.363 1.936 1.936 0 0 0 .58-.045v-.006l11.18-2.588a4.127 4.127 0 0 0 2.878-1.62 5.069 5.069 0 0 0 1.038-3.115V674.028h-.006a5.072 5.072 0 0 0-1.288-3.221 4.117 4.117 0 0 0-2.987-1.385 1.938 1.938 0 0 0-.63.057l.485 1.946-.485-1.945-8.876 2.3-9.124-8.632z",
    transform: "translate(-224.042 -646.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    className: "cls-1",
    d: "M263.808 433.471a6.589 6.589 0 0 1 4.716 1.989 6.879 6.879 0 0 1 0 9.6 6.583 6.583 0 0 1-9.431 0 6.879 6.879 0 0 1 0-9.6 6.589 6.589 0 0 1 4.715-1.989z",
    transform: "translate(-255.1 -433.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    className: "cls-1",
    d: "M750.681 741.583a.986.986 0 1 0 1.971 0v-4a.986.986 0 1 0-1.971 0z",
    transform: "translate(-718.241 -717.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    className: "cls-1",
    d: "M673.462 650.1h9.638a1 1 0 0 1 .986 1 1.01 1.01 0 0 1-.294.715l-4.812 4.9a.973.973 0 0 1-1.394 0l-.006-.006-4.811-4.9a1.017 1.017 0 0 1 0-1.419.974.974 0 0 1 .693-.29z",
    transform: "translate(-644.853 -636.508)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    style: {
      fill: "none"
    },
    d: "M0 0h126v128H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiterService);
export default __webpack_public_path__ + "static/media/waiterService.c85f0338ddee873767d0e4023d1c8e2d.svg";
export { ForwardRef as ReactComponent };